import { Box, styled } from '@mui/material';

export const StyledModalContent = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border: 1px solid #c0c7ca99;
  border-radius: 8px;
  overflow-y: auto;
  overflow-x: hidden;

  max-height: 95vh;
  &::-webkit-scrollbar {
    display: none;
  }
`;
